import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.2 }
  }
};

// Obfuscated email handler
const handleEmailClick = (e) => {
  e.preventDefault();
  // Encode email parts to reduce spam
  const user = 'info';
  const domain = 'discovify';
  const tld = 'ai';
  const email = `${user}@${domain}.${tld}`;
  window.location.href = `mailto:${email}`;
};

// Contact Form Section
const ContactFormSection = () => {
  return (
    <section className="relative py-24" data-testid="contact-form-section">
      <div className="absolute inset-0 bg-[#0E2A47]" />
      <div className="absolute inset-0 grid-overlay" />
      <div className="absolute inset-0 spotlight" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Content */}
          <motion.div
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
          >
            <motion.h1 
              variants={fadeInUp}
              className="font-heading text-4xl sm:text-5xl font-bold text-white leading-tight"
            >
              Contact Us To Start Your{' '}
              <span className="text-[#0FA4A9]">AI Journey</span>
            </motion.h1>
          </motion.div>

          {/* Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="glass-card rounded-sm p-8">
              <div className="min-h-[600px]" data-testid="ghl-contact-form-embed">
                <iframe
                  src="https://api.leadconnectorhq.com/widget/form/7jUh23KvQfjP97dgta3g"
                  style={{ width: '100%', height: '600px', border: 'none', borderRadius: '3px' }}
                  id="inline-7jUh23KvQfjP97dgta3g"
                  data-layout="{'id':'INLINE'}"
                  data-trigger-type="alwaysShow"
                  data-trigger-value=""
                  data-activation-type="alwaysActivated"
                  data-activation-value=""
                  data-deactivation-type="neverDeactivate"
                  data-deactivation-value=""
                  data-form-name="Discovify AI Website Contact Page"
                  data-height="undefined"
                  data-layout-iframe-id="inline-7jUh23KvQfjP97dgta3g"
                  data-form-id="7jUh23KvQfjP97dgta3g"
                  title="Discovify AI Website Contact Page"
                />
              </div>
            </div>

            {/* Email Alternative */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-8 text-center"
            >
              <p className="font-body text-sm text-white/60 mb-2">
                Prefer to email us?
              </p>
              <button
                onClick={handleEmailClick}
                className="inline-flex items-center gap-2 font-body text-[#0FA4A9] hover:text-[#0FA4A9]/80 transition-colors"
                data-testid="email-link"
              >
                <Mail className="h-4 w-4" />
                <span>info@discovify.ai</span>
              </button>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <ContactFormSection />
    </div>
  );
}
